import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResetService {
  private resetSubject = new Subject<void>();

  // Observable for components to subscribe
  resetObservable$ = this.resetSubject.asObservable();

  // Function to trigger reset
  triggerReset() {
    this.resetSubject.next();
  }
}
